// Lightweight analytics helper (GA4). No-ops if gtag is unavailable.
export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch {
    // Do nothing if analytics is not available
  }
}

export function trackFavoritesAdd(params) {
  trackEvent('favorites_add', params);
}

export function trackFavoritesRemove(params) {
  trackEvent('favorites_remove', params);
}

export function trackFavoritesToggleView(params) {
  trackEvent('favorites_toggle_view', params);
}

